import { useId } from "react";
import classes from "./classes.module.scss";
import InputElement, { EInputType } from "components/materials/Form/InputElement";
import MuiSelectInputElement from "components/materials/Form/MuiSelectInputElement";
import CheckboxesInputElement from "components/materials/Form/CheckboxesInputElement";

export function NumberField({
	label,
	value,
	onChange,
	percent = false,
	step = 0.01,
	readonly = false,
}: {
	label: string;
	value: number;
	onChange: (value: number) => void;
	percent?: boolean;
	step?: number;
	readonly?: boolean;
}) {
	const id = useId();
	return (
		<div className={classes["field"]}>
			<InputElement
				key={label}
				size="small"
				name={id}
				type={EInputType.NUMBER}
				label={label}
				defaultValue={Number.isFinite(value) ? (percent ? Number((value * 100).toFixed(6)) : value) : ""}
				step={step}
				readonly={readonly}
				onChange={(e) => onChange(e.target.value === "" ? NaN : Number(e.target.value) / (percent ? 100 : 1))}
			/>
		</div>
	);
}
export function Choice<T extends string>({
	label,
	value,
	options,
	onChange,
}: {
	label: string;
	value: T;
	options: [T, string][];
	onChange: (value: T) => void;
}) {
	const id = useId();
	return (
		<div className={classes["field"]}>
			<MuiSelectInputElement
				key={label}
				disablePortal={false}
				size="small"
				name={id}
				label={label}
				options={options.map(([id, label]) => ({ id, label }))}
				defaultValue={options.some(([id]) => id === value) ? { id: value, label: options.find(([id]) => id === value)![1] } : null}
				placeholder="Choisir une option"
				disableClearable
				onChange={(_, v) => v && onChange(v.id as T)}
			/>
		</div>
	);
}
export function Toggle({ label, checked, onChange }: { label: string; checked: boolean; onChange: (value: boolean) => void }) {
	const id = useId();
	return <CheckboxesInputElement name={id} options={[{ value: "enabled", label, checked }]} onChange={(e) => onChange(e.target.checked)} />;
}
export { money, percent } from "./format";
